import { render, staticRenderFns } from "./setPassword.vue?vue&type=template&id=492f26a8&scoped=true&"
import script from "./setPassword.vue?vue&type=script&lang=js&"
export * from "./setPassword.vue?vue&type=script&lang=js&"
import style0 from "./setPassword.vue?vue&type=style&index=0&id=492f26a8&prod&scoped=true&lang=less&"
import style1 from "./setPassword.vue?vue&type=style&index=1&id=492f26a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492f26a8",
  null
  
)

export default component.exports